import { createSelector } from 'reselect';
import { compose } from 'ramda';

import * as intervals from '../utils/intervals';
import { getSafeTimeBounds } from '../selectors/timeBounds';

export const getTimespan = state => state.dataSettingsDialog.timespan;
export const getMetric = state => state.dataSettingsDialog.metric;
export const getCompare = state => state.dataSettingsDialog.compare;
export const getPrecision = state => state.dataSettingsDialog.precision;
export const getCustomCompareInterval = state =>
  state.dataSettingsDialog.customCompareInterval;
export const getCustomTimespanInterval = state =>
  state.dataSettingsDialog.customTimespanInterval;
export const getDataSettingsDialogOpened = state =>
  state.dataSettingsDialog.dialogOpened;

export const getTotalTimespanInterval = createSelector(
  getTimespan,
  getSafeTimeBounds,
  getCustomTimespanInterval,
  intervals.totalTimespanInterval,
);

export const getTotalCompareInterval = createSelector(
  getTotalTimespanInterval,
  getCompare,
  getCustomCompareInterval,
  getSafeTimeBounds,
  compose(intervals.totalCompareInterval, intervals.compareIntervals),
);

export const getAvailableCompare = createSelector(
  getSafeTimeBounds,
  getTimespan,
  getCustomTimespanInterval,
  intervals.availableCompare,
);



// WEBPACK FOOTER //
// ./src/selectors/dataSettingsDialog.js